module.exports = __webpack_public_path__ + "img/capture.80761a81.png";